var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPl15(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 256 256"
    },
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: 256.16,
    height: 254.68,
    x: -0.16,
    y: 0.66,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 256.16,
    height: 254.68,
    x: -0.16,
    y: 0.66,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.53 254.25a15.93 15.93 0 0 0 12.7-.49l52.71-25.36c5.54-2.66 9.06-8.27 9.06-14.42V42.02c0-6.15-3.52-11.75-9.06-14.42L194.23 2.24a15.937 15.937 0 0 0-18.19 3.1L75.15 97.39 31.2 64.02a10.64 10.64 0 0 0-13.61.61L3.49 77.45c-4.65 4.23-4.65 11.54-.01 15.77L41.59 128 3.48 162.77c-4.64 4.24-4.64 11.55.01 15.78l14.1 12.82c3.8 3.46 9.52 3.71 13.61.61l43.95-33.36 100.9 92.05c1.6 1.59 3.47 2.8 5.48 3.58zm10.51-184.36L115.48 128l76.56 58.12V69.89z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#fff",
      filter: "url(#a)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#b)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m246.94 27.64-52.75-25.4C188.09-.7 180.79.54 176 5.33L3.32 162.77c-4.64 4.24-4.64 11.55.01 15.78l14.1 12.82c3.8 3.46 9.53 3.71 13.62.61L239 34.23c6.98-5.29 17-.32 17 8.44v-.61c0-6.15-3.52-11.76-9.06-14.42z",
    style: {
      fill: "#0065a9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m246.94 228.36-52.75 25.4c-6.1 2.94-13.4 1.7-18.19-3.09L3.32 93.23c-4.64-4.23-4.64-11.55.01-15.77l14.1-12.82c3.8-3.46 9.53-3.71 13.62-.61L239 221.77c6.98 5.29 17 .32 17-8.44v.61c0 6.15-3.52 11.76-9.06 14.42z",
    style: {
      fill: "#007acc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.2 253.76c-6.11 2.94-13.4 1.7-18.2-3.1 5.9 5.9 16 1.72 16-6.63V11.96c0-8.35-10.1-12.53-16-6.63a15.975 15.975 0 0 1 18.2-3.1l52.74 25.36c5.54 2.67 9.07 8.27 9.07 14.42v171.97c0 6.15-3.52 11.75-9.07 14.42l-52.74 25.36z",
    style: {
      fill: "#1f9cf0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.25
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 127.844,
    x2: 127.844,
    y1: 257.34,
    y2: 2.66,
    gradientTransform: "matrix(1 0 0 -1 0 258)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fff",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M181.38 254.25a15.93 15.93 0 0 0 12.7-.49l52.71-25.36c5.54-2.66 9.06-8.27 9.06-14.42V42.02c0-6.15-3.52-11.75-9.06-14.42L194.08 2.24a15.937 15.937 0 0 0-18.19 3.1L74.99 97.39 31.04 64.02a10.64 10.64 0 0 0-13.61.61L3.33 77.45c-4.65 4.23-4.65 11.54-.01 15.78L41.44 128 3.32 162.77c-4.64 4.24-4.64 11.55.01 15.78l14.1 12.82c3.8 3.46 9.52 3.71 13.61.61l43.95-33.36 100.9 92.05c1.6 1.59 3.47 2.8 5.49 3.58zm10.5-184.36L115.32 128l76.56 58.12V69.89z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#c)"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPl15);
export default __webpack_public_path__ + "static/media/pl15.858094b5444d5ff6c53ac0fb98623114.svg";
export { ForwardRef as ReactComponent };